/**
 * ============================================================================
 * PAYMENT PAGE - 100% Ready
 * ============================================================================
 * 
 * Page for making payments to transactions
 */

import React from 'react';
import { useParams } from 'react-router-dom';
import { UserDashboardLayout } from '../components/user';
import PaymentMethods from '../components/payment/PaymentMethods';
import CardPayment from '../components/payment/CardPayment';
import MobileMoneyPayment from '../components/payment/MobileMoneyPayment';

/**
 * Payment Page Component
 * @returns {JSX.Element}
 */
const Payment = () => {
  const { transactionId, methodId } = useParams();

  // If methodId is provided, show the specific payment method
  // Otherwise show payment methods selection
  if (methodId === 'card') {
    return (
      <UserDashboardLayout>
        <CardPayment />
      </UserDashboardLayout>
    );
  }

  if (methodId === 'mtn' || methodId === 'orange') {
    return (
      <UserDashboardLayout>
        <MobileMoneyPayment method={methodId} />
      </UserDashboardLayout>
    );
  }

  // Default: Show payment methods selection
  return (
    <UserDashboardLayout>
      <PaymentMethods
        transactionId={transactionId}
      />
    </UserDashboardLayout>
  );
};

export default Payment;
